import { Pagination } from "swiper/modules";

export const sliderSettings = {
  modules: [Pagination],
  pagination: {
    clickable: true,
  },
};
